export default [
    {
        title: 'control_asistencia.titulo',
        fontIcon: 'clipboard-list',
        resource: 'Control Costos',
        action: 'ver-control-costos',
        children: [
            {
                title: 'Menu',
                icon: 'MenuIcon',
                resource: 'Control Costos',
                action: 'ver-control-costos-menu',
                route: 'control-costos-menu',
            },
            {
                route: 'control-asistencia-menu',
                title: 'control_asistencia.menu.titulo',
                fontIcon: 'bars',
                resource: 'Control Costos',
                action: 'ver-control-asistencia-menu',
            },
            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Control Costos',
                action: 'ver-control-costos-configuracion',
                children: [
                    {
                        route: 'control-costos-configuracion-permisos',
                        title: 'Permisos',
                        resource: 'Control Costos',
                        action: 'ver-control-costos-configuracion-permisos',
                    },
                    {
                        route: 'control-asistencia-configuracion-permisos-seccion-rh',
                        title: 'control_asistencia.configuracion.permisos_secciones.titulo',
                        resource: 'Control Costos',
                        action: 'ver-control-asistencia-configuracion-permisos-seccion-rh',
                        fontIcon: 'house-lock',
                    },
                    {
                        route: 'control-asistencia-configuracion-turnos',
                        title: 'control_asistencia.configuracion.turnos.titulo',
                        resource: 'Control Costos',
                        action: 'ver-control-asistencia-configuracion-turnos',
                        fontIcon: 'calendar-days',
                    },
                ],
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Control Costos',
                action: 'ver-control-costos-mantenimiento',
                children: [
                    {
                        route: 'mantenimiento-seccion',
                        title: 'Seccion',
                        resource: 'Control Costos',
                        action: 'ver-control-costos-mantenimiento-seccion',
                    },
                    {
                        route: 'control-asistencia-mantenimiento-seccion-rh',
                        title: 'control_asistencia.mantenimiento.seccion.titulo',
                        resource: 'Control Costos',
                        action: 'ver-control-asistencia-mantenimiento-seccion-rh',
                        fontIcon: 'house',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Control Costos',
                action: 'ver-control-costos-informes',
                children: [
                    {
                        route: 'informe-listado-asistencia',
                        title: 'Listado de Asistencia',
                        resource: 'Control Costos',
                        action: 'ver-control-costos-informes-listado-asistencia',
                    },
                    {
                        route: 'control-asistencia-informes-asistencia',
                        title: 'Informe de Asistencia',
                        resource: 'Control Costos',
                        action: 'ver-control-asistencia-informes-asistencia',
                    },
                ],
            },
        ],
    },
]
